import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const LossCaseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  width: 100%;
  padding: 1rem 0;
`

export const LossCaseItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const LossCaseValueEm = styled.span<{ $color?: string }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(props) => props.$color || tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const LossClosureWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 0;
  border-top: 1px solid ${tokens.border.hairline};
`

export const LossApprovalBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.status.warning.bg};
  border: 1px solid ${tokens.border.hairline};
`

export const LossSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 0;
  border-top: 1px solid ${tokens.border.hairline};
`

export const LossScrollList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 10rem;
  overflow-y: auto;
  width: 100%;
`

export const LossNoteCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
`

export const LossModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
`
